var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgReportes(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 192 192",
    width: "1em",
    height: "1em",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "reportes_svg__cls-1",
    d: "M176.37 91.94a7.4 7.4 0 00-7.65 7.14 72.73 72.73 0 11-76.66-75.14 7.4 7.4 0 00-.8-14.77 87.52 87.52 0 1092.24 90.41 7.39 7.39 0 00-7.13-7.64z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "reportes_svg__cls-1",
    d: "M110.64 87.5h62.89a7 7 0 006.94-7.67 77.2 77.2 0 00-69.12-69.13h-.7a7 7 0 00-7 7v62.83a7 7 0 006.99 6.97zm7.82-60.62a62.5 62.5 0 0145.83 45.83h-45.83z"
  })));
}

export default SvgReportes;